var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('view',{staticClass:"video"},[_c('video',{ref:"vidref",attrs:{"id":"myVideo","src":_vm.url,"controls":"","autoplay":true,"page-gesture":true}})])}
var staticRenderFns = []

export { render, staticRenderFns }